import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    token: "",
    user: null,
    uaa: null,
    isAuthenticated: false,
    masterData: {},
    walletRequests: null,
    customFields: [],
    statuses: [],
    currencies: [
      {
        value: "USD",
        title: "Dollars",
      },
      {
        value: "INR",
        title: "Rupees",
      },
      {
        value: "Pounds",
        title: "Pounds",
      },
    ],
  },
  mutations: {
    login(state, token) {
      state.token = token;
      state.isAuthenticated = true;
    },
    populateMR(state, masterData) {
      state.masterData = masterData;
    },
    init(state) {
      state.createAgainMode = false;
    },
    user(state, account) {
      state.user = account.user;
    },
    uaa(state, uaa) {
      state.uaa = uaa;
    },
    logout(state)
    {
      state.isAuthenticated=false;
      sessionStorage.clear()
    },
    addWalletStatuses(state, statuses) {
      state.statuses = statuses;
    },
    addWalletRequests(state, requests) {
      state.walletRequests = requests;
    },
    addWalletRequest(state, request) {
      if (state.walletRequests === null) {
        state.walletRequests = [request];
      } else {
        state.walletRequests.unshift(request);
      }
    },
    updateWalletRequest(state, request) {
      let index = state.walletRequests.findIndex((w) => w.paymentRequestId === request.paymentRequestId);
      state.walletRequests.splice(index, 1, request);
    },
    addCustomFields(state, customFields) {
      state.customFields = customFields;
    },
  },
  getters: {
    createAgainMode: (state) => state.createAgainMode,
    state: (state) => state,
    token: (state) => state.token,
    user: (state) => state.user,
    uaa: (state) => state.uaa,
    isAuthenticated: (state) => state.isAuthenticated,
    masterData: (state) => state.masterData,
    hasMasterData: (state) => state.masterData,
    getWalletRequests: (state) => state.walletRequests,
    customFields: (state) => state.customFields,
    customFieldChoicesByName: (state) => (name) => {
      let fields = state.customFields.find((c) => c.name === name).choices.map((m) => m.label);
      fields.unshift("");
      return fields;
    },
    customFieldChoicesById: (state) => (id) => {
      let fields = state.customFields.find((c) => c.id === id).choices.map((m) => m.label);
      fields.unshift("");
      return fields;
    },
  },
  actions: {
    async logout(state) {
      state.token=null;
      state.isAuthenticated=false;
      state.user=null;
      sessionStorage.clear();
      this.authToken = null;
    },
  },
});
